module.exports = __webpack_public_path__ + "img/FontAwesome_Contact-Phone.9b58df08.svg";